<template>
  <DefaultLayout :loading="loading">
    <template #header>
      <div class="headerContainer">
        <h1 class="title">Vencimento das parcelas</h1>
        <span class="subtitle">
          Escolha o dia do mês que você prefere pagar seus parcelamentos.
        </span>
      </div>
    </template>
    <template #default>
      <div class="main-container">
        <section class="section-container">
          <InstallmentDateSelect
            @selectedDate="(value) => (selectedDate = value)"
            :currentOptions="installmentDates"
          />
          <span v-if="canShowError && !selectedDate" class="error-message fade-in"
            >Selecione uma data de vencimento.</span
          >
        </section>
      </div>
      <div class="button-container">
        <Button :disabled="sending" class="button" @click="sendExpirationDate">
          {{ sending ? 'Enviando...' : 'Continuar' }}
        </Button>
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import { defineComponent, onMounted, ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import InstallmentDateSelect from '@/feature/minified-onboarding/components/InstallmentDateSelect.vue';
import Button from '@/components/ui/AppButton.vue';
import DefaultLayout from '@/feature/minified-onboarding/layout/DefaultLayout.vue';
import Loader from '@/feature/minified-onboarding/components/Loader.vue';
import { useStore } from '@/utils/store';

export default defineComponent({
  name: 'ExpirationStepView',
  components: {
    Button,
    InstallmentDateSelect,
    Loader,
    DefaultLayout,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const sending = ref();
    const loading = ref(true);
    const canShowError = ref(false);
    const selectedDate = ref();

    const nextRoute = computed(() => store?.getters['minifiedOnboarding/nextRoute']);
    const installmentDates = computed(() => store?.getters['minifiedOnboarding/dueDayOptions']);

    async function sendExpirationDate() {
      if (!selectedDate.value) {
        canShowError.value = true;
        return;
      }

      canShowError.value = false;

      try {
        sending.value = true;
        await store.dispatch('minifiedOnboarding/sendExpirationDate', {
          dueDay: selectedDate.value,
        });
        await router.replace({
          name: nextRoute.value,
          query: route.query,
        });
        sending.value = false;
      } catch (error) {
        router.go(0);
        throw new Error(error);
      }
    }

    onMounted(async () => {
      const { userId, onboardingToken: token, onboardingId } = route.query;

      loading.value = true;
      await store?.dispatch('auth/setToken', { token });
      await store?.dispatch('minifiedOnboarding/getOnboarding', {
        userId,
        onboardingId,
      });
      loading.value = false;
    });

    return {
      sendExpirationDate,
      loading,
      sending,
      installmentDates,
      selectedDate,
      canShowError,
    };
  },
});
</script>

<style lang="scss" scoped>
.headerContainer {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  .title {
    display: flex;
    gap: 0.25rem;
    align-items: center;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight: 700;
  }

  .subtitle {
    font-size: 1rem;
    line-height: 1.5rem;
    color: #64748b;
  }
}
.main-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 24px;
  height: 100%;

  .section-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
  }

  .error-message {
    margin-top: 16px;
    word-break: break-all;
    font-size: 14px;
    line-height: 20px;
    color: #dc2626;
  }
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .button {
    display: flex;
    font-weight: 600;
    align-items: center;
    background: #ed0059;
    color: #ffffff;
    border: none;
    justify-content: center;
    border-radius: 24px;
    width: 100%;
    height: 48px;
  }
}
</style>
